import RevealMore from './revealMore';
import RevealMoreToggle from './revealMoreToggle';

export default (di) => {
	di
		.setType({type: RevealMore, name: 'RevealMore', parent: 'PageComponent'})
		.setType({type: RevealMoreToggle, name: 'RevealMoreToggle', parent: 'PageComponent'})
	;
};
